import * as actionTypes from './actionTypes';

export const fetchFinancialAdvisorsData = (payload) => ({
  type: actionTypes.userDataFetchType,
  payload,
});

export const enableBack = () => ({
  type: actionTypes.enableBackType,
});

export const resetEnableBack = () => ({
  type: actionTypes.resetEnableBackType,
});

export const lazyLoadFetch = (payload) => ({
  type: actionTypes.fetchLazyLoadDataType,
  payload,
});

export const resetData = () => ({
  type: actionTypes.resetAdvisorData,
});
